"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqData = [{
  question: "Diş eti tedavisi (küretaj) ağrılı bir işlem midir?",
  answer: "İşlem genellikle lokal anestezi altında yapıldığı için uygulama sırasında herhangi bir ağrı hissedilmez. Tedavi sonrasında hafif bir hassasiyet veya sızlama olabilir, ancak bu durum hekiminizin önereceği basit ağrı kesicilerle kontrol altına alınabilir ve birkaç gün içinde kendiliğinden geçer."
}, {
  question: "Diş eti çekilmesi kendiliğinden düzelir mi?",
  answer: "Hayır, diş eti çekilmesi geri dönüşü olmayan bir süreçtir ve genellikle profesyonel müdahale gerektirir. Tedavi edilmediğinde kök yüzeyleri açığa çıkar ve diş kaybına yol açabilir. Erken teşhis ve doğru tedavi yöntemleriyle bu süreç durdurulabilir ve diş etlerinin sağlığı korunabilir."
}, {
  question: "Tedavi süreci ne kadar sürer?",
  answer: "Tedavi süresi, diş eti hastalığının şiddetine ve yaygınlığına bağlıdır. Hafif diş eti iltihaplarında (jinjivit) tek seanslık profesyonel temizlik yeterli olabilirken, ileri seviye periodontitis durumlarında ağzın farklı bölgeleri için birkaç seanslık bir planlama gerekebilir."
}, {
  question: "Diş eti kanaması normal bir durum mudur?",
  answer: "Diş fırçalarken veya yemek yerken oluşan kanamalar kesinlikle normal değildir ve genellikle bir diş eti iltihabının habercisidir. Sağlıklı diş etleri açık pembe renklidir, sıkıdır ve fırçalama ile kanamaz. Kanama fark ettiğinizde vakit kaybetmeden uzman bir diş hekimine muayene olmanız önerilir."
}, {
  question: "Lazerle diş eti tedavisi mümkün müdür?",
  answer: "Evet, kliniğimizde lazer teknolojisi kullanarak daha konforlu, kanamasız ve hızlı iyileşme sağlayan modern diş eti tedavileri uygulamaktayız. Lazer, enfekte dokuların temizlenmesinde ve sterilizasyon sağlanmasında oldukça etkili bir yöntemdir."
}, {
  question: "Tedavi sonrası nelere dikkat edilmelidir?",
  answer: "Tedavi sonrası ağız hijyenine maksimum özen gösterilmeli, hekiminizin önerdiği özel fırçalama teknikleri ve arayüz fırçaları düzenli kullanılmalıdır. Ayrıca ilk birkaç gün aşırı sıcak veya soğuk gıdalardan kaçınılmalı ve rutin kontroller aksatılmamalıdır."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30195" id="benefits-procedure-details" ref={ref} className={`py-16 md:py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold font-serif text-primary mb-4 tracking-tight">
              Sıkça Sorulan Sorular
            </h2>
            <p className="text-muted-foreground text-lg font-sans">
              Diş eti sağlığınız ve tedavi süreçlerimiz hakkında en çok merak edilen soruların yanıtları.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-0">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0" data-index={i}>
                <AccordionTrigger className="text-left text-base md:text-xl font-serif font-semibold text-foreground hover:text-primary hover:no-underline py-6 transition-colors duration-300 data-[state=open]:text-primary">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6 font-sans">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}